import { type UseQueryResult, useQuery } from 'react-query';
import { CompanySsoConfigurationService } from '../../services/wealthlane-identity-services';
import { OptionType } from '../../types/common';

const useGetProviderTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<OptionType[] | undefined, unknown> => {
  const providerTypes = useQuery(
    ['getProviderTypes'],
    async () => {
      return await handleRequest(
        CompanySsoConfigurationService.getApiIdentityApiAppCompanySsoConfigurationProviderTypes()
      );
    },
    {
      select: (data) => data?.map((item) => ({ label: item, value: item })),
    }
  );

  return providerTypes;
};

export default useGetProviderTypes;
